<template>
  <div class="ProblemFeedbackNotice">
    <div class="switch-row flex a-c j-s">
      <div class="switch-title">前台显示</div>
      <div class="flex a-c">
        <el-switch
            @change="confirm"
            :active-value="1"
            :inactive-value="0"
            v-model="state.params.feedbackNoticeFlag"
            :before-change="beforeChange"
            active-color="#2054D6"
            size="large"
        />
        <div class="expand-toggle flex a-c" @click="noticeExpanded = !noticeExpanded">
          <span>{{ noticeExpanded ? '收起' : '展开' }}</span>
          <el-icon><ArrowUp v-if="noticeExpanded" /><ArrowDown v-else /></el-icon>
        </div>
      </div>
    </div>
    <div class="switch-tip">该开关控制前台问题反馈公告是否显示</div>

    <div class="editor-wrap">
      <div class="editor-collapse-wrap" :class="noticeExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor ref="contentRef" :defaultId="'contentRef'" key="contentRef"
          @update:modelValue="updateContent" />
      </div>
    </div>

    <div class="button-container flex a-c j-c" style="margin-top: 20px">
      <el-button color="#626aef" @click="submit">保存</el-button>
      <el-button color="#626aef" plain @click="reset">重置</el-button>
    </div>
  </div>
</template>

<script>
import {
  findOneUnifyNoticeBySid, updateUnifyNoticeBySid,
  findOneGlobalSettingBySid, updateSystemGlobalSettingBySid
} from "@/js/network/main"

import tinyMceEditor from "@/components/untils/tinyMceEditor"
import {onMounted, reactive, ref} from "vue";
import {ElMessageBox} from "element-plus";
import {MessageBox} from "@/js/utils/commonJs";

export default {
  name:'ProblemFeedbackNotice',
  components: {
    tinyMceEditor
  },

  setup(props, {attrs, slots, emit, expose}) {
    let content = ref("");
    let contentCopy = "";

    let contentRef = ref(null);

    // 前台显示开关（与全局设置共用字段）
    let isFirst = ref(true);
    let state = reactive({
      params: {},
    });

    // 公告富文本默认收起
    let noticeExpanded = ref(false);

    const confirm = () => {
      if(isFirst.value){
        return;
      }
      // 开关打开时展开公告编辑器；关闭时收起
      if(state.params.feedbackNoticeFlag == 1){
        noticeExpanded.value = true;
      } else {
        noticeExpanded.value = false;
      }
      updateSystemGlobalSettingBySid(state.params).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        console.log(error,"catchError");
      });
    }
    const beforeChange = function () {
      isFirst.value = false;
      return new Promise((resolve, reject) => {
        ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
          if (aaa) {
            resolve(true);
          }
          reject(false);
        }).catch(() => {
          reject(false);
        })
      })
    }
    const initSetting = function () {
      findOneGlobalSettingBySid().then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if(!res || !res.data){
          return;
        }
        state.params = res.data;
        // 回显开关为开启状态时，公告编辑器默认展开
        noticeExpanded.value = res.data.feedbackNoticeFlag == 1;
      }).catch(error => {
        console.log(error,"catchError");
      });
    }
    const updateContent = (val) => {
      content.value = val;
    }
    const init = function () {
      findOneUnifyNoticeBySid(2).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if(!res || !res.data){
          return;
        }
        content.value = res.data.content;
        contentCopy = res.data.content;
        contentRef.value.handleSetContent(content.value);
      }).catch(error => {
        console.log(error,"catchError");
      });
    }
    const submit = () => {
      ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
        if (aaa) {
          let params ={
            type: 2,
            content:content.value
          }
          updateUnifyNoticeBySid(params).then(res => {
            if (!res.success) {
              MessageBox.error(res.msg);
              return;
            }
            MessageBox.success("保存成功！")
          }).catch(error => {
            console.log(error,"catchError");
          });
        }
      }).catch(() => {
      })

    }
    const reset = () => {
      content.value = contentCopy;
      contentRef.value.handleSetContent(content.value);
    }
    onMounted(()=>{
      setTimeout(()=>{
        init();
      },400)

    })
    initSetting();

    return {
      updateContent,
      contentRef,
      submit,
      reset,
      noticeExpanded,
      state,
      confirm,
      beforeChange
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ProblemFeedbackNotice{
  height: calc(100vh - 180px);
  overflow: hidden;
}

.editor-wrap{
  height: calc(100vh - 320px);
  overflow-y: auto;
}

.switch-row{
  padding: 4px 0 8px 0;

  .switch-title{
    color: #2B3348;
    font-size: 16px;
    font-weight: 600;
  }

  .expand-toggle{
    margin-left: 16px;
  }
}

.editor-collapse-wrap{
  &.collapsed{
    max-height: 0;
    overflow: hidden;
  }
}

.expand-toggle{
  font-size: 13px;
  color: #257dd9;
  cursor: pointer;
  user-select: none;
  gap: 4px;
}

.switch-tip{
  color: #6573A2;
  font-size: 14px;
  margin-bottom: 12px;
}
</style>
